export default __webpack_public_path__ + "static/media/mohsenin.e1debf78.jpg";